const doseUnitFragment = `
{
    shorthand,
    title,
    _updatedAt
}
`;

export default doseUnitFragment;
